<template>
  <section class="trust-section" id="trust">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">{{ $t('trust.title') }}</h2>
        <p class="section-subtitle">
          {{ $t('trust.subtitle') }}
        </p>
      </div>

      <div class="trust-grid">
        <div class="trust-card">
          <h3 class="trust-title">{{ $t('trust.park') }}</h3>
          <p class="trust-desc">
            {{ $t('trust.parkDesc') }}
          </p>
          <ul class="trust-list">
            <li>{{ $t('trust.parkItem1') }}</li>
            <li>{{ $t('trust.parkItem2') }}</li>
            <li>{{ $t('trust.parkItem3') }}</li>
          </ul>
        </div>

        <div class="trust-card">
          <h3 class="trust-title">{{ $t('trust.university') }}</h3>
          <p class="trust-desc">
            {{ $t('trust.universityDesc') }}
          </p>
          <ul class="trust-list">
            <li>{{ $t('trust.universityItem1') }}</li>
            <li>{{ $t('trust.universityItem2') }}</li>
            <li>{{ $t('trust.universityItem3') }}</li>
          </ul>
        </div>

        <div class="trust-card">
          <h3 class="trust-title">{{ $t('trust.tech') }}</h3>
          <p class="trust-desc">
            {{ $t('trust.techDesc') }}
          </p>
          <ul class="trust-list">
            <li>{{ $t('trust.techItem1') }}</li>
            <li>{{ $t('trust.techItem2') }}</li>
            <li>{{ $t('trust.techItem3') }}</li>
          </ul>
        </div>
      </div>

      <div class="whitepaper-callout" id="investor">
        <div class="whitepaper-content">
          <h3>{{ $t('trust.whitepaperTitle') }}</h3>
          <p>
            {{ $t('trust.whitepaperDesc') }}
          </p>
        </div>
        <button class="whitepaper-button">
          {{ $t('trust.whitepaperBtn') }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TrustSection'
}
</script>

<style scoped>
.trust-section {
  padding: 5rem 0 4.5rem;
  background: linear-gradient(135deg, #020617 0%, #020617 40%, #020617 100%);
  position: relative;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.section-title {
  font-size: 2.1rem;
  font-weight: 700;
  color: #F9FAFB;
  margin-bottom: 0.75rem;
}

.section-subtitle {
  font-size: 1rem;
  color: #9CA3AF;
  max-width: 640px;
  margin: 0 auto;
}

.trust-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.75rem;
}

.trust-card {
  border-radius: 18px;
  padding: 1.75rem 1.5rem 1.5rem;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(148, 163, 184, 0.6);
  background: radial-gradient(circle at 0% 0%, rgba(56, 189, 248, 0.16) 0, transparent 55%),
              radial-gradient(circle at 100% 100%, rgba(129, 140, 248, 0.24) 0, transparent 55%),
              rgba(15, 23, 42, 0.96);
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.85);
}

.trust-title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #F9FAFB;
  margin-bottom: 0.5rem;
}

.trust-desc {
  font-size: 0.9rem;
  color: #E5E7EB;
  margin-bottom: 0.8rem;
}

.trust-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.trust-list li {
  font-size: 0.85rem;
  color: #9CA3AF;
  position: relative;
  padding-left: 1.1rem;
}

.trust-list li::before {
  content: '•';
  position: absolute;
  left: 0;
  top: 0;
  color: #22D3EE;
}

.whitepaper-callout {
  margin-top: 3rem;
  padding: 1.75rem 2rem;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  background: linear-gradient(135deg, rgba(56, 189, 248, 0.18), rgba(129, 140, 248, 0.28));
  border: 1px solid rgba(191, 219, 254, 0.8);
}

.whitepaper-content h3 {
  font-size: 1.2rem;
  font-weight: 700;
  color: #F9FAFB;
  margin-bottom: 0.4rem;
}

.whitepaper-content p {
  font-size: 0.9rem;
  color: #F9FAFB;
}

.whitepaper-button {
  border: none;
  padding: 0.9rem 1.6rem;
  border-radius: 999px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  background: linear-gradient(135deg, #0F172A, #020617);
  color: #E5E7EB;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.7);
  white-space: nowrap;
}

.whitepaper-button:hover {
  transform: translateY(-1px);
}

@media (max-width: 768px) {
  .container {
    padding: 0 1rem;
  }

  .trust-grid {
    grid-template-columns: 1fr;
  }

  .section-title {
    font-size: 1.7rem;
  }

  .whitepaper-callout {
    flex-direction: column;
    align-items: flex-start;
    padding: 1.5rem 1.4rem;
  }

  .whitepaper-button {
    width: 100%;
    text-align: center;
  }
}
</style>

